import { render, staticRenderFns } from "./dialog-grades-upload.vue?vue&type=template&id=7282e894&"
import script from "./dialog-grades-upload.vue?vue&type=script&lang=js&"
export * from "./dialog-grades-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports